export default function temporaryAnalytics(pageTitle) {
  if (pageTitle === 'Explore a career with Lexus | Lexus.com') {
    return {
        page: 'Careers',
        section: 'Careers'
    }
  }
  if (pageTitle === 'Lexus Accessibility | Lexus.com') {
    return {
        page: 'Accessibility',
        section: 'Accessibility'
    }
  }
  if (pageTitle === 'About Lexus | Lexus.com') {
    return {
        page: 'About Page',
        section: 'Overview'
    }
  }
  if (pageTitle === 'About Lexus | Manufacturing | Lexus.com') {
    return {
        page: 'About Page',
        section: 'Manufacturing'
    }
  }
  if (pageTitle === 'About Lexus | Technology | Lexus.com') {
    return {
        page: 'About Page',
        section: 'Technology'
    }
  }
  if (pageTitle === 'About Lexus | Environment | Lexus.com') {
    return {
        page: 'About Page',
        section: 'Environment'
    }
  }
  if (pageTitle === 'About Lexus | Philanthropy | Lexus.com') {
    return {
        page: 'About Page',
        section: 'Philanthropy'
    }
  }
  if (pageTitle === 'Your Privacy Rights | Lexus.com') {
    return {
        page: 'Privacy Page',
        section: 'Privacy'
    }
  }
  if (pageTitle === 'Lexus Legal Terms | Lexus.com') {
    return {
        page: 'Privacy Page',
        section: 'Legal'
    }
  }
  if (pageTitle === 'Lexus Online Privacy Statement | Lexus.com') {
    return {
        page: 'Privacy Page',
        section: 'Online Statement'
    }
  }
  if (pageTitle === 'Lexus Offers | Experience Amazing') {
    return {
      page: 'All Offers',
      section: 'Offers',
    };
  }
};